import { GroupType } from '@/types/api/group';
import { groupNameLabels, groupTypeLabels, organizationNameLabels } from '@/utils/group/group-label-maps';
import * as React from 'react';

export function useGroupPropertyLabels(type: GroupType) {
  return React.useMemo(
    () => ({
      groupName: groupNameLabels[type],
      organizationName: organizationNameLabels[type],
      groupType: groupTypeLabels[type],
    }),
    [type],
  );
}
